var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-light",staticStyle:{"margin-top":"50px"}},[_c('p',[_vm._v("You have not access to this page ")]),_c('router-link',{attrs:{"to":"/"}},[_vm._v("Back to home page")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }